import React, { Component } from 'react';
// 3rd Party
import { Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import AnimateHeight from 'react-animate-height';
import v4 from 'uuid';
// Styles
import './BulletEntry.css';

class BulletEntry extends Component {
  state = {
    height: 0,
  };

  toggle = () => {
    this.setState({ height: this.state.height ? 0 : 'auto' });
  }

  render() {
    const { height } = this.state;
    const dropdownAnimationTime = 500; // ms

    return (
      <Row className="BulletEntry">
        <Col xs={12} xsOffset={0} md={10} mdOffset={1}>
          <h2 onClick={ this.toggle } className="bullet-entry-title">
            <FontAwesome
              className={height ? 'fa-rotate-90' : ''}
              name='caret-right'
              size='2x'
              style={{
                transition: `all ${dropdownAnimationTime}ms ease-out`,
                textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)'
              }}
            />
            {this.props.title}
          </h2>
          <AnimateHeight
            duration={ dropdownAnimationTime }
            height={ height } >
            {
              this.props.contentArr
              .map((contentStr) => (
                <p
                  key={v4()}
                  className="lead info" >
                  {contentStr}
                </p>
              ))
            }
          </AnimateHeight>
        </Col>
      </Row>
    );
  }
}

export default BulletEntry;



// WEBPACK FOOTER //
// ./src/presentationComponents/BulletEntry.js